// keyrd_console/src/components/PilotGovernanceBanner.js
import React from "react";
import PilotDataSourceBadge from "./PilotDataSourceBadge";
import PilotStatusPill from "./PilotStatusPill";

const wrapperStyle = {
  display: "flex",
  flexDirection: "column",
  gap: 10,
  padding: 16,
  borderRadius: 12,
  background: "#f8fafc",
  border: "1px solid #cbd5e1",
  marginBottom: 16,
};

const rowStyle = {
  display: "flex",
  flexWrap: "wrap",
  gap: 8,
  alignItems: "center",
};

const titleStyle = {
  fontSize: 16,
  fontWeight: 700,
  color: "#0f172a",
};

const metaStyle = {
  fontSize: 13,
  color: "#334155",
};

const warningStyle = {
  padding: "10px 12px",
  borderRadius: 10,
  background: "#fff7ed",
  color: "#9a3412",
  border: "1px solid #fdba74",
  fontSize: 13,
  fontWeight: 600,
};

function kv(label, value) {
  return (
    <span style={metaStyle}>
      <strong>{label}:</strong> {value || "unknown"}
    </span>
  );
}

function PilotGovernanceBanner({ auth = {}, system = {} }) {
  const pilotMode = system.pilot_mode || auth.pilotMode || "stage0_dry_run";
  const activeReleaseId = system.active_release_id || auth.activeReleaseId;
  const protocolVersion = system.protocol_version || auth.protocolVersion;
  const registryVersion = system.registry_version || auth.registryVersion;
  const registryHash = system.registry_hash || auth.registryHash;
  const shadowOnly = system.shadow_only_mode ?? true;
  const rlBlocked = system.rl_updates_blocked ?? true;
  const liveIssuanceEnabled = system.live_issuance_enabled ?? false;
  const systemPause = system.system_pause ?? false;
  const dataSource = system.data_source || (system.stub ? "stub" : "unknown");

  return (
    <div style={wrapperStyle}>
      <div style={rowStyle}>
        <div style={titleStyle}>Pilot Governance</div>
        <PilotDataSourceBadge source={dataSource} stub={Boolean(system.stub)} />
      </div>

      <div style={rowStyle}>
        <PilotStatusPill status={pilotMode} label={`Mode: ${pilotMode}`} />
        <PilotStatusPill
          status={shadowOnly ? "true" : "false"}
          label={shadowOnly ? "Shadow-Only" : "Shadow Disabled"}
        />
        <PilotStatusPill
          status={rlBlocked ? "true" : "false"}
          label={rlBlocked ? "RL Updates Blocked" : "RL Updates Enabled"}
        />
        <PilotStatusPill
          status={liveIssuanceEnabled ? "true" : "false"}
          label={liveIssuanceEnabled ? "Live Issuance Enabled" : "Live Issuance Disabled"}
        />
        <PilotStatusPill
          status={systemPause ? "paused" : "active"}
          label={systemPause ? "System Paused" : "System Running"}
        />
      </div>

      <div style={rowStyle}>
        {kv("Release", activeReleaseId)}
        {kv("Protocol", protocolVersion)}
        {kv("Registry", registryVersion)}
      </div>

      <div style={rowStyle}>
        {kv("Registry Hash", registryHash)}
        {system.last_updated_utc ? kv("Last Updated", system.last_updated_utc) : null}
      </div>

      {system.mismatch_warning ? (
        <div style={warningStyle}>{system.mismatch_warning}</div>
      ) : null}
    </div>
  );
}

export default PilotGovernanceBanner;